import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

@inject('store')
@observer
class Left extends Component {
    render() {
        const { data } = this.props.store.general;
        const Occupancy = data.Occupancy || {};
        const Occ = (Object.entries(Occupancy).map(x => x[1]).reduce((a, b) => a <= Number(b) ? Number(b) : a, 0) * 100).toFixed(2);
        return (
            <div className="content">
                <div className="title">入住率 Occ%</div>
                {/* <div className="text">6888</div> */}
                <div id="BI_title_center" style={{ height: 160 }}> </div>
                <div className="foot">最高入住率 Highest：{Occ}%</div>
            </div>
        );
    }
}

export default Left;


// WEBPACK FOOTER //
// ./src/components/BI/home/title/Center.js